import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const About = () => {
  return (
    <AboutSection
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <Title>{'<About />'}</Title>
      <Content>
        <TextContainer>
          <Paragraph>
            Hello! I'm Tahia, a passionate developer who loves creating
            beautiful and functional web applications. My journey in web development
            started when I joined the Software Department at Metropolitan University in my second year. During these two years, I have gained a solid understanding of coding, and I’ve learned how to apply it to real-world problems. You can learn more about my university through this link: 
            <a href="https://metrouni.edu.bd/" target="_blank" rel="noopener noreferrer">Metropolitan University</a>.
          </Paragraph>
          <Paragraph>
            Here are some technologies I've been working with recently:
          </Paragraph>
          <SkillsList>
            <SkillItem>JavaScript (ES6+)</SkillItem>
            <SkillItem>React</SkillItem>
            <SkillItem>Node.js</SkillItem>
            <SkillItem>TypeScript</SkillItem>
            <SkillItem>HTML & CSS</SkillItem>
            <SkillItem>Git</SkillItem>
          </SkillsList>
        </TextContainer>
        <ImageContainer>
          <ProfileImage src="your-image.jpg" alt="Profile" />
        </ImageContainer>
      </Content>
    </AboutSection>
  );
};

const AboutSection = styled(motion.section)`
  min-height: 100vh;
  padding: 100px 10% 0;
`;

const Title = styled.h2`
  color: #64ffda;
  font-size: 2rem;
  margin-bottom: 2rem;
`;

const Content = styled.div`
  display: grid;
  grid-template-columns: 3fr 2fr;
  gap: 50px;
  align-items: center;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const TextContainer = styled.div``;

const Paragraph = styled.p`
  margin-bottom: 1rem;
  line-height: 1.6;
`;

const SkillsList = styled.ul`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
  list-style: none;
  margin-top: 20px;
`;

const SkillItem = styled.li`
  color: #8892b0;
  &:before {
    content: '▹';
    color: #64ffda;
    margin-right: 10px;
  }
`;

const ImageContainer = styled.div`
  position: relative;
  &:before {
    content: '';
    position: absolute;
    top: 10px;
    left: 10px;
    width: 100%;
    height: 100%;
    border: 2px solid #64ffda;
    border-radius: 4px;
    z-index: -1;
  }
`;

const ProfileImage = styled.img`
  width: 100%;
  border-radius: 4px;
  filter: grayscale(100%);
  transition: filter 0.3s ease;

  &:hover {
    filter: none;
  }
`;

export default About;
